import DamageGrid from "./damage-grid";

import "./damage-grids.scss";


const DamageGrids = {
    All : DamageGrid
};

export default DamageGrids;